import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    OnestBoldBig,
    OnestNormalBig,
} from "../../../components/styled/TextComponents";
import {
    color_grey_light,
    color_red_default,
    color_white,
} from "../../../constants/colors";
import { MODAL_Z_INDEX_NESTED } from "../../../constants/layers";
import { weekDayToFullWeekName } from "../JournalPage";
import PersonalDefaultPage from "../PersonalDefaultPage";

import axios from "axios";
import moment from "moment-timezone";
import ModalQuestion from "../../../components/blocks/ModalQuestion";
import ModalSimple from "../../../components/blocks/ModalSimple";
import { get_user } from "../../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import ModalNote from "../../../components/blocks/SchedulePage/ModalNote";
import ModalPersonalTask from "../../../components/blocks/SchedulePage/ModalPersonalTask";
import ModalReschedule from "../../../components/blocks/SchedulePage/ModalReschedule";
import { Button } from "../../../components/controls/Button/Button";
import ArrowIconLeft from "../../../components/icons/ArrowIconLeft";
import Config from "../../../Config";
import { updateDayLessonData } from "../../../store/ScheduleDayExtendedSlice";
import { updateSchdeule } from "../../../store/ScheduleSlice";
import { updateStudent } from "../../../store/StudentSlice";
import { setUser, updateUser } from "../../../store/UserSlice";
import { buildLessonPaymentStatusMap } from "../../../utilities/getUserLessonStatus";
import { isLessonPast } from "../../../utilities/lessonHistoryUtils";
import { DayTimeline } from "./DayTimeline";
import { useI18n } from "../../../i18n/I18nProvider";

const AddEventButton = ({ onClick }) => {
  const { t } = useI18n();
  return (
  <div title={t("Добавить событие")}>
    <Button
      type="button"
      width={36}
      height={36}
      backgroundColor={color_red_default}
      borderColor={color_red_default}
      color={color_white}
      fontSize={24}
      onClick={onClick}
      style={{
        borderRadius: 8,
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
      }}
    >
      +
    </Button>
  </div>
  );
};

function getLessonWordEnding(quantity) {
  const lastDigit = quantity % 10;
  const lastTwoDigits = quantity % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return "ий";
  }
  if (lastDigit === 1) {
    return "ие";
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return "ия";
  }
  return "ий";
}

const GoBackButton = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        backgroundColor: color_white,
        color: color_red_default,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={() => navigate(-1)}
    >
      <ArrowIconLeft />
    </div>
  );
};

const ScheduleHeader = () => {
  const { t } = useI18n();
  const user = useSelector((state) => state.user);
  const timeZone =
    user.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone; // Замените на ваш часовой пояс по умолчанию

  const gDate = moment(); // Текущее время
  console.warn("gDate SchedulePage", gDate.format());
  const formattedDate = gDate.tz(timeZone); // Преобразование даты в нужный часовой пояс

  const dayData = useSelector((state) => state.scheduleDayExtended);
  const monthNames = [
    "Января",
    "Февраля",
    "Марта",
    "Апреля",
    "Мая",
    "Июня",
    "Июля",
    "Августа",
    "Сентября",
    "Октября",
    "Ноября",
    "Декабря",
  ];

  if (!dayData?.date) {
    return null;
  }
  const dateObject = moment(dayData?.date).tz(timeZone);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <OnestBoldBig>
          {dateObject.date()} {t(monthNames[dateObject.month()])},{" "}
        </OnestBoldBig>
        <OnestNormalBig style={{ color: color_grey_light, marginLeft: 8 }}>
          {" "}
          {dateObject.year()}
        </OnestNormalBig>
      </div>
    </div>
  );
};

export const ScheduleDayExtended = () => {
  const { t } = useI18n();
  const user = useSelector((state) => state.user);
  const timeZone =
    user.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone; // Замените на ваш часовой пояс по умолчанию
  const navigate = useNavigate();
  const gDate = moment(); // Текущее время
  console.warn("gDate SchedulePage", gDate.format());
  const formattedDate = gDate.tz(timeZone); // Преобразование даты в нужный часовой пояс

  const dispatch = useDispatch();
  const schedule = useSelector((state) => state.schedule);

  const student = useSelector((state) => state.student);

  const dayData = useSelector((state) => state.scheduleDayExtended);

  const [isLoading, setIsLoading] = useState(true);
  const [isShowModalNote, setIsShowModalNote] = useState(false);
  const [isShowModalReschedule, setIsShowModalReschedule] = useState(false);
  const [rescheduleInitialMode, setRescheduleInitialMode] =
    useState("reschedule");
  const [lessonForModal, setLessonForModal] = useState({});
  const [modalSuccessText, setModalSuccessText] = useState("");
  const [modalAlertText, setModalAlertText] = useState("");
  const [modalErrorText, setModalErrorText] = useState("");
  const [isPersonalTaskModalOpen, setIsPersonalTaskModalOpen] = useState(false);
  const [personalTaskForModal, setPersonalTaskForModal] = useState(null);
  const [isConfirmDeleteTaskOpen, setIsConfirmDeleteTaskOpen] = useState(false);
  const [pendingDeleteTask, setPendingDeleteTask] = useState(null);
  const [isDeletingPersonalTask, setIsDeletingPersonalTask] = useState(false);

  async function loadData() {
    let [lessonsResponse, personalEventsResponse] = await Promise.all([
      axios.get(Config.BACKEND_ADDR + "/lessons/"),
      axios.get(Config.BACKEND_ADDR + "/personal-events/"),
    ]);
    let lessonsData = lessonsResponse.data;
    let personalEventsData = personalEventsResponse.data || [];
    let uniqueStudents = lessonsData
      .map((el) => el.student_id)
      .filter((value, index, array) => array.indexOf(value) === index);
    let studentsBalance = {};
    for (let studentId of uniqueStudents) {
      const studentResponse = await axios.get(
        Config.BACKEND_ADDR + `/students/${studentId}`,
      );
      studentsBalance[studentId] = {
        balance: studentResponse.data.balance,
        cost: studentResponse.data.lesson_cost,
      };
    }

    const paymentStatuses = buildLessonPaymentStatusMap(
      lessonsData,
      studentsBalance,
    );
    let newLessonMap = lessonsData.map((el) => {
      let startTime = moment.utc(el.start_time).tz(timeZone);
      let endTime = moment.utc(el.end_time).tz(timeZone);
      return {
        id: el.id,
        eventType: "lesson",
        studentName: el.student_name,
        studentId: el.student_id,
        dateDate: startTime.toISOString(),
        endDateDate: endTime.toISOString(),
        timeSlot: `${startTime.format("HH:mm")} - ${endTime.format("HH:mm")}`,
        paymentStatus: paymentStatuses.get(el.id) || "Не оплачено",
        weekDay: weekDayToFullWeekName(el.weekday).short,
        studentLevel: el.student_level,
        note: el.note,
        cost: studentsBalance[el.student_id].cost,
        lessonQuantityText: t("{{count}} занят{{ending}}", {
          count: el.quantity,
          ending: getLessonWordEnding(el.quantity),
        }),
      };
    });

    const personalEventMap = personalEventsData.map((event) => {
      const startTime = moment.utc(event.start_time).tz(timeZone);
      const endTime = moment.utc(event.end_time).tz(timeZone);
      return {
        id: `personal-${event.id}`,
        personalEventId: event.id,
        eventType: "personal",
        title: event.title,
        note: event.note,
        dateDate: startTime.toISOString(),
        endDateDate: endTime.toISOString(),
        timeSlot: `${startTime.format("HH:mm")} - ${endTime.format("HH:mm")}`,
      };
    });
    const mergedEvents = [...newLessonMap, ...personalEventMap];

    await dispatch(updateSchdeule(mergedEvents));

    const lessons = mergedEvents.filter((lesson) => {
      const lessonDate = moment(lesson?.dateDate);
      return lessonDate.isSame(moment(dayData?.date), "day");
    });
    dispatch(updateDayLessonData({ date: dayData?.date, lessons: lessons }));
  }

  const memoOpenModalNote = useCallback((lesson) => {
    setLessonForModal(lesson);
    setIsShowModalNote(true);
  }, []);

  const memoOpenModalReschedule = useCallback((lesson) => {
    if (isLessonPast(lesson, timeZone)) {
      memoOpenModalNote(lesson);
      return;
    }
    setRescheduleInitialMode("reschedule");
    setLessonForModal(lesson);
    setIsShowModalReschedule(true);
  }, [timeZone, memoOpenModalNote]);

  const deleteLesson = useCallback((lesson) => {
    if (isLessonPast(lesson, timeZone)) {
      return;
    }
    setRescheduleInitialMode("delete_free");
    setLessonForModal(lesson);
    setIsShowModalReschedule(true);
  }, [timeZone]);

  const memoCloseModalNote = useCallback(() => {
    setLessonForModal({});
    setIsShowModalNote(false);
  }, []);

  const memoSaveNote = useCallback(
    async (comment, commentOption, lessonData) => {
      const updateLesson = async (lessonIdForUpd) => {
        try {
          let updRes = await axios.patch(
            Config.BACKEND_ADDR + `/lessons/note/`,
            {
              lesson_id: lessonIdForUpd,
              note: comment,
            },
          );
          return updRes;
        } catch (error) {
          return error;
        }
      };

      const successAction = async () => {
        setLessonForModal({});
        //setIsShowModalNote(false);
        await loadData();
        setModalSuccessText(t("Заметка добавлена"));
      };

      if (commentOption === "lesson") {
        try {
          let resUpd = await updateLesson(lessonData.id);
          if (resUpd.status === 200) {
            await successAction();
          } else {
            console.error("Error updating lesson:", resUpd.data);
            setModalErrorText(t("Ошибка обновления урока"));
          }
        } catch (error) {
          console.error("Error updating lesson:", error);
        } finally {
          return true;
        }
      } else {
        let numberDays = commentOption === "week" ? 7 : moment().daysInMonth();

        let lessonsForUpdate = schedule.filter((el) => {
          const lessonDate = moment(el.dateDate).tz(timeZone);
          const startDate = moment(lessonData.dateDate).tz(timeZone);
          const endDate = moment(lessonData.dateDate)
            .tz(timeZone)
            .add(numberDays - 1, "days")
            .endOf("day");

          return (
            lessonDate.isSameOrAfter(startDate) &&
            lessonDate.isSameOrBefore(endDate) &&
            el.studentId === lessonData.studentId
          );
        });
        try {
          for (const lesson of lessonsForUpdate) {
            let resUpd = await updateLesson(lesson.id);
            if (resUpd.status === 200) {
              //await successAction();
            } else {
              console.error("Error updating lesson:", resUpd.data);
              setModalErrorText(t("Ошибка обновления урока"));
            }
          }

          await successAction();
        } catch (error) {
          console.error("Error updating lesson:", error);
        } finally {
          return true;
        }
      }
    },
    [t],
  );

  const memoSaveDateTime = useCallback(
    async (dateTime, isDelete, isPaid, lessonData) => {
      if (isLessonPast(lessonData, timeZone)) {
        setModalErrorText(t("Нельзя изменять прошедший урок"));
        return false;
      }

      const [startHour, startMinute] = lessonData.timeSlot
        .split(" - ")[0]
        .split(":")
        .map(Number);
      const [endHour, endMinute] = lessonData.timeSlot
        .split(" - ")[1]
        .split(":")
        .map(Number);

      const intervalMinutes =
        endHour * 60 + endMinute - (startHour * 60 + startMinute);
      console.warn(`The interval is ${intervalMinutes} minutes.`);

      //суда dateTime передаётся из модального окна уже в формате UTC
      const endDateTimeUTC = dateTime + intervalMinutes * 60;

      const handleDatetimeError = (error) => {
        const status = error.response?.status;
        const detail = error.response?.data?.detail;
        if (status === 409) {
          setModalAlertText(
            t("У вас уже есть уроки в это время ( {{date}} ). Пожалуйста, проверьте расписание и выберите другой слот.", { date: moment.utc(detail).tz(timeZone).format("DD.MM.YYYY HH:mm") }),
          );
          return;
        }
        if (status === 400 && typeof detail === "string") {
          setModalErrorText(detail);
          return;
        }
        if (status >= 500) {
          setModalErrorText(t("Ошибка сервера, попробуйте ещё раз"));
          return;
        }
        setModalErrorText(t("Ошибка обновления урока"));
      };

      const successAction = async (text) => {
        setLessonForModal({});
        await loadData();
        setModalSuccessText(text ? text : t("Изменения сохранены"));
      };

      if (isDelete) {
        try {
          let resDelete = await axios.delete(
            Config.BACKEND_ADDR + `/lessons/${lessonData.id}/`,
          );

          if (resDelete.status !== 200) {
            console.error("Error updating lesson:", resDelete.data);
            setModalErrorText(t("Ошибка удаления урока"));
            return false;
          }

          setModalAlertText(
            t("Вы удаляете только текущий урок. Если вам нужно внести постоянные изменения в расписание, это можно сделать в карточке ученика."),
          );
          await successAction(t("Занятие удалено"));

          if (isPaid) {
            let countOfHalfHours = Math.floor(intervalMinutes / 30);
            let paySum = +lessonData.cost * countOfHalfHours;
            console.warn("countOfHalfHours", countOfHalfHours);
            console.warn("paySum", paySum);

            let newBalance = +student.balance - +paySum;
            let resUpdStudent = await axios.patch(
              Config.BACKEND_ADDR + `/students/balance/`,
              {
                balance: newBalance,
                student_id: lessonData.studentId,
              },
            );
            if (resUpdStudent.status === 200) {
              dispatch(
                updateStudent({
                  studentId: lessonData.studentId,
                  balance: newBalance,
                }),
              );
            } else {
              console.error(
                "Error updating student balance:",
                resUpdStudent.data,
              );
              setModalErrorText(t("Ошибка обновления баланса ученика"));
            }
            let userBalance = user.balance ? user.balance : 0;
            const newTeacherBalance = +userBalance + +paySum;
            let resUpdTeacher = await axios.patch(
              Config.BACKEND_ADDR + `/auth/teacher/balance/`,
              {
                balance: newTeacherBalance,
              },
            );
            if (resUpdTeacher.status === 200) {
              dispatch(updateUser({ balance: newTeacherBalance }));
            } else {
              console.error(
                "Error updating teacher balance:",
                resUpdTeacher.data,
              );
              setModalErrorText(t("Ошибка обновления баланса учителя"));
            }
          }
          return true;
        } catch (error) {
          console.error("Error updating lesson:", error);
          const status = error.response?.status;
          const detail = error.response?.data?.detail;
          if (status === 400 && typeof detail === "string") {
            setModalErrorText(detail);
          } else if (status >= 500) {
            setModalErrorText(t("Ошибка сервера, попробуйте ещё раз"));
          } else {
            setModalErrorText(t("Ошибка удаления урока"));
          }
          return false;
        }
      }

      try {
        const resUpd = await axios.patch(
          Config.BACKEND_ADDR + `/lessons/datetime/`,
          {
            lesson_id: lessonData.id,
            start_time: dateTime,
            end_time: endDateTimeUTC,
          },
        );
        if (resUpd.status === 200) {
          setModalAlertText(
            t("Перенос произойдет однократно. Если вам нужно внести постоянные изменения в расписание, это можно сделать в карточке ученика."),
          );
          await successAction();
          return true;
        }
        console.error("Error updating lesson:", resUpd.data);
        setModalErrorText(t("Ошибка обновления урока"));
        return false;
      } catch (error) {
        console.error("Error updating lesson:", error);
        handleDatetimeError(error);
        return false;
      }
    },
    [t],
  );

  const memoCloseModalReschedule = useCallback(() => {
    setLessonForModal({});
    setRescheduleInitialMode("reschedule");
    setIsShowModalReschedule(false);
  }, []);

  const openCreatePersonalTaskModal = useCallback(() => {
    setPersonalTaskForModal(null);
    setIsPersonalTaskModalOpen(true);
  }, []);

  const openEditPersonalTaskModal = useCallback((task) => {
    setPersonalTaskForModal(task);
    setIsPersonalTaskModalOpen(true);
  }, []);

  const closePersonalTaskModal = useCallback(() => {
    setPersonalTaskForModal(null);
    setIsPersonalTaskModalOpen(false);
  }, []);

  const savePersonalTask = useCallback(
    async (payload, eventId) => {
      try {
        if (eventId) {
          await axios.patch(
            Config.BACKEND_ADDR + `/personal-events/${eventId}`,
            payload,
          );
        } else {
          await axios.post(Config.BACKEND_ADDR + "/personal-events/", payload);
        }
        await loadData();
        setModalSuccessText(
          t(eventId ? "Личное событие обновлено" : "Личное событие создано"),
        );
        return true;
      } catch (error) {
        if (error.response?.status === 409) {
          const detailDate = error.response?.data?.detail;
          const detailText = detailDate
            ? moment.utc(detailDate).tz(timeZone).format("DD.MM.YYYY HH:mm")
            : "";
          setModalAlertText(
            detailText
              ? t("В это время уже есть событие ({{date}}). Выберите другой слот.", { date: detailText })
              : t("В это время уже есть событие. Выберите другой слот."),
          );
        } else {
          setModalErrorText(t("Не удалось сохранить личное событие"));
        }
        return false;
      }
    },
    [timeZone, t],
  );

  const deletePersonalTask = useCallback((task) => {
    setPendingDeleteTask(task);
    setIsDeletingPersonalTask(false);
    setIsConfirmDeleteTaskOpen(true);
  }, []);

  const handleConfirmDeletePersonalTask = useCallback(
    async (isConfirmed) => {
      if (!isConfirmed || !pendingDeleteTask || isDeletingPersonalTask) {
        setIsConfirmDeleteTaskOpen(false);
        setPendingDeleteTask(null);
        setIsDeletingPersonalTask(false);
        return;
      }
      setIsDeletingPersonalTask(true);
      try {
        await axios.delete(
          Config.BACKEND_ADDR +
            `/personal-events/${pendingDeleteTask.personalEventId}`,
        );
        await loadData();
        setModalSuccessText(t("Личное событие удалено"));
        setIsConfirmDeleteTaskOpen(false);
      } catch (error) {
        setModalErrorText(t("Не удалось удалить личное событие"));
        setIsConfirmDeleteTaskOpen(false);
      } finally {
        setPendingDeleteTask(null);
        setIsDeletingPersonalTask(false);
      }
    },
    [pendingDeleteTask, isDeletingPersonalTask, t],
  );

  useEffect(() => {
    let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod"; // /api
    axios
      .get(backendAddr)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === "not_paid") {
            navigate("/billing/");
          }
        }
      })
      .catch((err) => {
        console.warn("Ошибка проверки подписки в БД! ", err);
      });
  }, [navigate]);

  useEffect(() => {
    (async () => {
      console.log("navbaruser ", user);
      if (!user || Object.keys(user).length === 0) {
        try {
          const data = await get_user();
          dispatch(setUser(data));
        } catch (error) {
          console.error("Error fetching user data:", error);
          // Обработка ошибки, например, перенаправление на страницу входа
          //navigate('/auth/login');
        }
      }
    })();
  }, [dispatch, user]);

  return (
    <PersonalDefaultPage>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <ModalSimple
          type={"success"}
          h2={modalSuccessText}
          isOpen={modalSuccessText !== ""}
          onClose={setModalSuccessText}
          zIndex={MODAL_Z_INDEX_NESTED}
        ></ModalSimple>
        <ModalSimple
          type={"alert"}
          h2={modalAlertText}
          isOpen={modalAlertText !== ""}
          onClose={setModalAlertText}
          buttonText={t("Хорошо")}
          zIndex={MODAL_Z_INDEX_NESTED}
        ></ModalSimple>
        <ModalSimple
          type={"error"}
          h2={modalErrorText}
          isOpen={modalErrorText !== ""}
          onClose={setModalErrorText}
          zIndex={MODAL_Z_INDEX_NESTED}
        ></ModalSimple>
        <ModalQuestion
          type={"question"}
          h2={t("Удалить личное событие?")}
          p={t("Вы уверены, что хотите удалить это событие?")}
          isOpen={isConfirmDeleteTaskOpen}
          onClose={handleConfirmDeletePersonalTask}
          yesText={t(isDeletingPersonalTask ? "Удаляем..." : "Удалить")}
          noText={t(isDeletingPersonalTask ? "Подождите..." : "Отмена")}
          isLoading={isDeletingPersonalTask}
          zIndex={MODAL_Z_INDEX_NESTED}
        />
        <ModalPersonalTask
          isOpen={isPersonalTaskModalOpen}
          onClose={closePersonalTaskModal}
          onSave={savePersonalTask}
          initialTask={personalTaskForModal}
          existingEvents={schedule}
        />
        {isShowModalNote && (
          <ModalNote
            lessonData={lessonForModal}
            isOpen={isShowModalNote}
            onClose={memoCloseModalNote}
            onSave={memoSaveNote}
          />
        )}
        {isShowModalReschedule && (
          <ModalReschedule
            lessonData={lessonForModal}
            isOpen={isShowModalReschedule}
            onClose={memoCloseModalReschedule}
            onSave={memoSaveDateTime}
            initialActionMode={rescheduleInitialMode}
          />
        )}
        <GoBackButton />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            width: "100%",
          }}
        >
          <div style={{ minWidth: 0, flex: 1 }}>
            <ScheduleHeader />
          </div>
          <div style={{ flexShrink: 0 }}>
            <AddEventButton onClick={openCreatePersonalTaskModal} />
          </div>
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: color_white,
            borderRadius: 20,
            padding: 20,
            boxSizing: "border-box",
            overflowX: "auto",
          }}
        >
          <DayTimeline
            events={dayData?.lessons || []}
            timeZone={timeZone}
            onOpenModalReschedule={memoOpenModalReschedule}
            onOpenModalNote={memoOpenModalNote}
            onOpenPersonalTaskModal={openEditPersonalTaskModal}
            onDeletePersonalTask={deletePersonalTask}
            onDeleteLesson={deleteLesson}
          />
        </div>
      </div>
    </PersonalDefaultPage>
  );
};
